import { useScrollFadeIn } from "@/hooks/useScrollFadeIn";

export default function ScheduleSection() {
  const { ref: headRef, style: headStyle } = useScrollFadeIn<HTMLDivElement>();
  const { ref: cardRef, style: cardStyle } = useScrollFadeIn<HTMLDivElement>({ delay: 0.15 });

  return (
    <section id="schedule" className="py-20 md:py-14 bg-stone-50">
      <div className="max-w-3xl mx-auto px-4 md:px-10">
        <div ref={headRef} style={headStyle} className="text-center mb-5 md:mb-8">
          <p className="text-xs md:text-sm tracking-[0.4em] text-amber-700 uppercase mb-2 md:mb-3">Schedule</p>
          <h2
            className="font-en text-3xl md:text-4xl font-normal text-stone-800 tracking-widest"
          >
            Schedule
          </h2>
          <div className="w-12 h-0.5 bg-amber-400 mx-auto mt-4 md:mt-5"></div>
        </div>

        <div ref={cardRef} style={cardStyle} className="bg-white border border-stone-200 p-5 md:p-8">
          <div className="space-y-4 md:space-y-6 text-sm md:text-lg text-stone-600 leading-relaxed">
            <div className="flex items-start gap-3 md:gap-4">
              <div className="w-7 h-7 md:w-8 md:h-8 flex items-center justify-center flex-shrink-0">
                <i className="ri-calendar-close-line text-amber-600 text-lg md:text-xl"></i>
              </div>
              <div>
                <p className="font-medium text-stone-700 mb-1 tracking-wider text-sm md:text-base">定休日</p>
                <p>平日の水曜日・金曜日はお休みです。</p>

              </div>
            </div>

            <div className="w-full h-px bg-stone-200"></div>

            <div className="flex items-start gap-3 md:gap-4">
              <div className="w-7 h-7 md:w-8 md:h-8 flex items-center justify-center flex-shrink-0">
                <i className="ri-store-2-line text-amber-600 text-lg md:text-xl"></i>
              </div>
              <div>
                <p className="font-medium text-stone-700 mb-1 tracking-wider text-sm md:text-base">お仕置きBAR</p>
                <p>月に一度、週末に四谷Studio All-inにてお仕置きBARのママをしています。</p>
              </div>
            </div>

            <div className="w-full h-px bg-stone-200"></div>

            <div className="flex items-start gap-3 md:gap-4">
              <div className="w-7 h-7 md:w-8 md:h-8 flex items-center justify-center flex-shrink-0">
                <i className="ri-information-line text-stone-400 text-lg md:text-xl"></i>
              </div>
              <div>
                <p className="text-stone-500 leading-relaxed">
                  ご予約状況やスケジュールは日々変わるため、最新のご案内は下記のカレンダーよりご確認ください。
                </p>
              </div>
            </div>
          </div>

          <div className="mt-8 text-center">
            <a
              href="https://lit.link/hatomugicha91"
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="inline-flex items-center gap-3 px-8 py-4 bg-stone-800 text-white text-[15px] tracking-[0.2em] font-medium active:bg-stone-700 active:scale-[0.97] transition-all duration-200 cursor-pointer whitespace-nowrap rounded-lg"
            >
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-calendar-line text-base"></i>
              </div>
              カレンダーを確認する
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
